export type ToolId =
  | "briefings"
  | "monitoring"
  | "similarity"
  | "clustering"
  | "analytics"
  | "wordcloud"
  | "competitor-analysis";
export interface WorkspaceScope {
  userId: string;
  organizationId: string;
}
export interface ToolListState {
  q: string;
  status: string;
  sort: "updated" | "name";
  view: "projects" | "recent";
  page: number;
}
export const scopeKey = (scope: WorkspaceScope | null) =>
  scope
    ? `${encodeURIComponent(scope.userId)}:${encodeURIComponent(scope.organizationId)}`
    : "";
